import React from 'react'
import { Image, ImageProps } from '@chakra-ui/react'
import { useAuthCredentials } from 'hooks'
import { signUrl } from 'utils/aws/util'

export const SignedImage = ({ src, ...props }: ImageProps) => {
  const credentials = useAuthCredentials()
  return <Image src={signUrl(src, credentials)} {...props} />
}
